<template>
  <div id="luksofors" class="kt-checkbox-inline" v-if="cursel.length > 0">
    <div
      v-for="(status, idx) in cursel"
      :key="idx"
      class="kt-badge"
      :class="{ clickable: !readonly }"
      :style="`background-color: ${status.color}`"
      @click="setStatus(idx)"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import { api } from '@/libs/apiLocal'

const props = defineProps<{
  engine: string
  id: number | string
  readonly?: boolean
}>()
const cursel = defineModel<iStatusOne[]>({ default: [] })

function setStatus(index: number) {
  if (props.readonly) {
    return
  }
  api
    .put<iStatus>(`/status/next/${props.engine}/${props.id}/${cursel.value[index].status_name}`)
    .then((res) => {
      cursel.value = res.data.status_full
    })
}
</script>
